import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext({ settings: null, services: [], reload: () => {} });

function injectGA(id) {
  if (!id || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id);
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);

  const reload = async () => {
    const [s, sv] = await Promise.all([api.get("/settings"), api.get("/services")]);
    setSettings(s.data);
    setServices(sv.data);
    injectGA(s.data?.ga_measurement_id);
  };

  useEffect(() => { reload().catch(() => {}); }, []);

  return <SettingsContext.Provider value={{ settings, services, reload }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
